import React from 'react';
import Icon from '../Icon';
import { I18n } from 'react-redux-i18n';

const Notification = ({ notification }) => {
  if (!notification.is_active) {
    return (
      <p className="notavailable">{I18n.t('admin.services.soonAvailable')}</p>
    );
  } else if (notification.disabled) {
    return (
      <a
        target="_blank"
        href="mailto:c.ruel@wine-services.com"
        rel="noreferrer"
      >
        <p>{I18n.t('admin.services.notIncluded')}</p>
      </a>
    );
  } else {
    return (
      <div className="available">
        <Icon icon="check" />
      </div>
    );
  }
};

export default Notification;
